import Vue from 'vue'

const client = Vue.prototype.$api

export function getCountries () {
	return client.get('/countries')
}

export function getAllStates (criteria = { specialty: null, service: null, withProfessionals: false, withCenters: false }) {
	return client.get('states', { params: criteria })
}

export function getStates (criteria = { countryId: null, specialty: null, professional: null, service: null }) {
	return client.get('states', { params: criteria })
}

export function getStatesByCountry (countryId = null) {
	return getStates({ countryId })
}

export function getStateCities (stateId) {
	return client.get(`cities/${stateId}`)
}

export function getProfStates(criteria = {specialty, appointmentType}) {
	return client.get('states/getProfStates', { params: criteria })
}

export function getCenterStates (criteria = {specialty, appointmentType}) {
	return client.get('states/getCenterStates', { params: criteria })
}

export function getStatesByService (serviceId) {
	return client.get('states/GetStatesByService', { params: { serviceId: serviceId } })
}

export default {
	getCountries,
	getAllStates,
	getStates,
	getStatesByCountry,
	getStateCities,
	getProfStates,
	getCenterStates,
	getStatesByService
}



// WEBPACK FOOTER //
// ./src/repositories/GeographyRepository.js